module.exports = __webpack_public_path__ + "5c1ac2852ed1a86edb8e48a63aba95be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/owl-dobe-desert-casa-empty.png
// module id = 332
// module chunks = 0